<template>
    <div
        id="modal-anonymize"
        aria-hidden="true"
        aria-labelledby="modalFillInLabel"
        class="modal modal-default modal-delete"
        role="dialog"
        tabindex="-1"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <header class="modal-header">
                    <button aria-hidden="true" class="close" data-dismiss="modal" type="button">
                        <!-- TODO extract svg -->
                        <svg fill="none" height="18" viewBox="0 0 18 18" width="18" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17.375 0.625C16.875 0.0625 16.0625 0.0625 15.5 0.625L9 7.125L2.5 0.625C1.9375 0.0625 1.125 0.0625 0.625 0.625C0.0625 1.125 0.0625 1.9375 0.625 2.5L7.125 9L0.625 15.5C0.0625 16.0625 0.0625 16.875 0.625 17.375C1.125 17.9375 1.9375 17.9375 2.5 17.375L9 10.875L15.5 17.375C16.0625 17.9375 16.875 17.9375 17.375 17.375C17.9375 16.875 17.9375 16.0625 17.375 15.5L10.875 9L17.375 2.5C17.9375 2 17.9375 1.125 17.375 0.625Z" fill="#676486" />
                        </svg>
                    </button>

                    <strong>{{ __('Anonymise the patient') }}</strong>
                    <p v-html="__('Do you really want to anonymise (delete) this patient <span>:name</span>?', {name: userToAnonymize.fullname})"></p>
                </header>

                <div class="modal-body">
                    <div class="btn-group">
                        <VButton :label="__('Cancel')" modal-target="dismiss" variant="secondary" />
                        <VButton :label="__('Yes, anonymise')" modal-target="dismiss" type="submit" color="danger" @onClick="anonymize" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        userToAnonymize: {
            required: true
        }
    },
    data() {
        return {
            formData: {}
        }
    },
    methods: {
        anonymize() {
            var that = this

            if (this.userToAnonymize.type === "pending") {
                this.formData = {
                    pending_patient_id: this.userToAnonymize.id
                }
            } else {
                this.formData = {
                    user_id: this.userToAnonymize.id
                }
            }

            this.$emit('success', false)

            axios
                .post(`user/anonymization`, this.formData)
                .then(function (response) {
                    that.$emit('success', true)
                })
                .catch(function (error) {
                    console.log(error)
                })
        }
    }
}
</script>
